<div class="flex-grow-1">
  <p-selectButton
    [options]="inboxTabOptions"
    [(ngModel)]="selectedTab"
    (onChange)="tabChanged.emit(selectedTab)"
    class="inbox-tabs-select-button"
  >
    <ng-template let-item>
      {{ item.label }}
      <span class="ui-badge">
        <span *ngIf="loading"><i class="fa fa-spin fa-spinner"></i></span>
        <span *ngIf="!loading && counts != null && Object.keys(counts).length > item.value">{{
          counts[item.value]
        }}</span>
      </span>
    </ng-template>
  </p-selectButton>
</div>
